import * as d3 from 'd3'
export default {

  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.box      = json.box
      this.bullet   = json.bullet
      this.status   = json.status
      
      this.keys     = json.keys
      this.filters  = json.filters
      this.sundries = json.sundries


      this.gmx_tableCoordinates('x', this.status.columns, 0)
      this.status.width = this.status.columns[this.status.columns.length-1].ex


      this.scale = d3.scaleLinear()
      .domain([0, this.rawData.length-1])
      .range([this.box.prog.SColor, this.box.prog.EColor])
      .interpolate(d3.interpolateRgb)

    },

  }
}